import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography } from '../../Typography/Typography';
export const Label = ({ label, size }) => {
    const typographySize = useMemo(() => (size === 'md' ? 'sm' : 'md'), [size]);
    if (typeof label === 'string' || typeof label === 'number')
        return (_jsx(Typography.Text, { "data-testid": 'description-label', ellipsis: true, whiteSpace: 'nowrap', size: typographySize, weight: 'regular', color: 'neutral-500', children: label }));
    return _jsx(_Fragment, { children: label });
};
